import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeServiceTypeForAllItemsCommand extends BaseCommand {
  CommandName = "ChangeServiceTypeForAllItems";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
